import React from 'react';
import { Col, Row, Panel, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime/DateTime';

const categoryList = [
  { id: 'Tobacco', name: 'Tobacco' },
  { id: 'Vape', name: 'Vape' },
  { id: 'Oral Tobacco', name: 'Oral Tobacco' }
];

const renderList = (list) => {
  return (
    Object.keys(list).map(item => {
      return (<option key={list[item].id} value={list[item].id}>{list[item].name}</option>);
    })
  );
};

const PromotionalBannersSearchPanel = (props) => {
  const {
    groupValue,
    categoryValue,
    onGroupChange,
    onCategoryChange,
    groupList,
    displayFromDateValue,
    handleDisplayFromDateChange,
    displayToDateValue,
    handleDisplayToDateChange,
    onApply,
    onClearFilters
  } = props;

  return (
    <Panel className="order-filter">
      <Row>
        <Col md={8}>
          <FormGroup>
            <FormControl
              value={groupValue}
              onChange={onGroupChange}
              componentClass="select"
            >
              <option value="">[Group]</option>
              { renderList(groupList) }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={4}>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup>
            <FormControl
              value={categoryValue}
              onChange={onCategoryChange}
              componentClass="select"
            >
              <option value="">Select Category</option>
              { renderList(categoryList) }
            </FormControl>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={displayFromDateValue}
              onChange={handleDisplayFromDateChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Display from date'
              }}/>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={displayToDateValue}
              onChange={handleDisplayToDateChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Display to date'
              }}/>
          </FormGroup>
        </Col>
        <Col md={4} className="actions">
          <Button
            className="red-ghost-btn"
            onClick={onApply}>Apply</Button>
          <Button
            className="red-ghost-btn"
            onClick={onClearFilters}>Clear filters</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default PromotionalBannersSearchPanel;



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotional_banners/list/promotional-banners-search-panel.jsx